import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { IMessengerConnector } from '../../../types/all.type';
import {InterfaceService} from '../../../services/interface.service';

@Component({
  selector: 'app-chat-search',
  templateUrl: './chat-search.component.html',
  styleUrls: ['./chat-search.component.css']
})
export class ChatSearchComponent implements OnInit {
  @Input() Service: IMessengerConnector;
  Form: UntypedFormGroup;
  constructor(
    public interfaceService: InterfaceService,
  ) {}

  ngOnInit() {
    this.initForms();
  }
  initForms() {
    this.Form = new UntypedFormGroup({
      q: new UntypedFormControl('', Validators.minLength(3))
    });
  }

  onSubmit() {
    const controls = this.Form.controls;
    const values = this.Form.value;

    // Проверяем форму на валидность */
    if (this.Form.invalid) {
      // Если форма не валидна, помечаем все контролы как touched **/
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    this.Service.getGlobalSearch(values.q, 150).subscribe(
      (result: any) => {},
      (error) => {
        this.interfaceService.errorHandling(error);
      }
    );
  }
}
